/* eslint-disable @typescript-eslint/no-unused-vars */ // just while we wait for BE to catch up
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cloneDeep } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectControls } from '../../redux/controls';
import { changePDSelections, selectPDSelections, selectPDSelectors } from '../../redux/explorePanel';
import { JurisdictionInfo, StatisticsList, SubgroupsList, VariableList } from '../../redux/explorePanel/models';
import { loadItemPerformanceDataStart, selectItem } from '../../redux/itemDetail';
import { selectItemRequest, loadDownloadStart, loadDownloadCancel, selectIdsForDownload, selectDownloading, selectDownloadProgress } from '../../redux/queryResults';
import { DownloadRequest } from '../../redux/queryResults/models';
import { selectSystemID } from '../../redux/queryPanel';
import { PDOutputType, StatType } from '../../shared';
import Modal from '../Modals/Modal';
import { WindowType } from '../Modals/models/Modal.types';
import NQTCheckBox from '../NQTCheckBox/NQTCheckBox';
import { CHECKBOX_GROUP_TYPES, isCHECKBOX_GROUP_TYPES } from '../NQTCheckBox/NQTCheckBox.models';
import NQTMixedCheckBox from '../NQTMixedCheckBox/NQTMixedCheckBox';
import { IMixedCheckBox } from '../NQTMixedCheckBox/NQTMixedCheckBox.models';
import Spinner from '../Spinner/Spinner';
import './ExplorePanel.scss';
import { JURIS_INFO, STAT_LIST, SUBGROUPS_LIST, EXCEL_OPTION, PDTABLE, VARIABLE_LIST, PDCHART, SE_ON, SE_OFF } from './models';
import { DownloadFormatsDict, ITEM_LIST_COL_HEADER_LABELS, ITEM_LIST_DB_COLUMNS, EXCEL_OPT_TYPE } from '../DownloadPanel/models';
import { DownloadEnums, DownloadPanelProps } from '../DownloadPanel/models/DownloadPanel.interfaces';
import { PerformanceDataOutput, StandardErrorOptions } from './models/ExplorePanel.types';
import { DOWNLOAD_FORM, DOWNLOAD_TYPES } from '../../redux/queryResults/models/queryResults.types';
import { isPerformanceDataOutput, isStandardErrorOptions, jurisInfoReducer, statisticsListReducer, subgroupsListReducer, variableListReducer } from './models/ExplorePanel.utils';
import { NQTRadioButton } from '../NQTRadioButton/NQTRadioButton';
import ga4 from '../../shared/analyticsEvents';

const childStyle = {
  paddingLeft: '32px',
  paddingTop: '5px'
};

export const ExplorePanel = ({tabData}: DownloadPanelProps):JSX.Element => {
  const explorePanelEl = useRef<HTMLDivElement>(null);
  const onFocusEl = useRef<HTMLButtonElement>(null);
  const systemID = useSelector(selectSystemID);
  const idsForDownload = useSelector(selectIdsForDownload);
  const isDownloading = useSelector(selectDownloading);
  const downloadProgress = useSelector(selectDownloadProgress);

  //radio-input Refs for focus control
  const radioOutput1 = useRef<HTMLSpanElement>(null);
  const radioOutput2 = useRef<HTMLSpanElement>(null);
  const radioStandardError1 = useRef<HTMLSpanElement>(null);
  const radioStandardError2 = useRef<HTMLSpanElement>(null);


  const dispatch = useDispatch();

  const controls = useSelector(selectControls);
  const item = useSelector(selectItem);
  const itemRequest = useSelector(selectItemRequest);
  const pdSelectors = useSelector(selectPDSelectors);
  const pdSelections = useSelector(selectPDSelections);

  //tracks collapsed/expanded states
  const [accExpanded, setAccExpanded] = useState<boolean>(false);
  const [jurisExpanded, setJurisExpanded] = useState<boolean>(false);
  const [varExpanded, setVarExpanded] = useState<boolean>(false);
  const [statExpanded, setStatExpanded] = useState<boolean>(false);

  const [hideCheckboxes, setHideCheckboxes] = useState<boolean>(false);
  const [disableExcelOptions, setDisableExcelOptions] = useState<boolean>(true);

  //checkbox fields state
  const [jurisInfoTrees, setJurisInfoTrees] = useState<IMixedCheckBox<JurisdictionInfo>[]|null>(null);
  const [variablesList, setVariablesList] = useState<VariableList[]|null>(null);
  const [subgroupsList, setSubgroupsList] = useState<SubgroupsList[]|null>(null);
  const [statisticsList, setStatisticsList] = useState<StatisticsList[]|null>(null);

  const [selectedFormat, setSelectedFormat] = useState<DOWNLOAD_FORM>(DOWNLOAD_FORM.EXCEL);

  const [excelOptsForDownload, setExcelOptsForDownload] = useState<DownloadEnums[]>([]);

  //radio-input state
  const [selectedOutput, setSelectedOutput] = useState<PerformanceDataOutput>(PDCHART);
  const [selectedStandardError, setSelectedStandardError] = useState<StandardErrorOptions>(SE_OFF);

  //selectedCheckboxes state
  const [selectedJurisInfo, setSelectedJurisInfo] = useState<IMixedCheckBox<JurisdictionInfo>[]|null>(null);
  const [selectedVariables, setSelectedVariables] = useState<VariableList[]|null>(null);
  const [selectedSubgroups, setSelectedSubgroups] = useState<SubgroupsList[]|null>(null);
  const [selectedStatistics, setSelectedStatistics] = useState<StatisticsList[]|null>(null);

  const [isValid, setIsValid] = useState<boolean>(true);
  const [isDownloadValid, setIsDownloadValid] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] =useState<boolean>(true);
  const [isDownloadDisabled, setIsDownloadDisabled] =useState<boolean>(false);
  //const [isDownloadComplete, setIsDownloadComplete] = useState<boolean>(false);

  // variables to trap user focus to queryPanel
  const [keepFocus, setKeepFocus] = useState<boolean>(false);
  const [keepDwnDataFocus, setkeepDwnDataFocus] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalType, setModalType] = useState<WindowType>('DESC');

  const [formats, setFormats] = useState<DownloadEnums[]>([]);

  // Tracks whether the download in progress was initiated from this component instance,
  // so the progress indicator is only shown underneath the button that was clicked.
  const [localDownloading, setLocalDownloading] = useState<boolean>(false);

  // For external link: used specifically to sync explorePanel state on reset i.e. when user selects new criteria
  // on queryPanel
  const [manuallyTriggerApply, setManuallyTriggerApply] = useState<boolean>(false);




  const openPerformanceTab = useCallback(() => {
    const performanceTabBtn = document.getElementById('pills-performance-tab');
    if (performanceTabBtn && !manuallyTriggerApply) {
      performanceTabBtn.click();
    }
  },[manuallyTriggerApply]);

  const onApply = useCallback(() => {

    const jurisdictionsSelected = selectedJurisInfo?.reduce((acc, curr, ind, arr) => {
      const delimiter = acc ? ',' : '';
      if (curr.isSelected) {
        acc += delimiter + curr.childList.map(child => child.jurisdictionCode).join(',');
      } else {
        acc += delimiter + curr.childList.filter( child => child.isSelected ).map( child => child.jurisdictionCode ).join(',');
      }
      return acc;
    }, '');

    const output = selectedOutput === PDCHART ?
      PDOutputType.OUTPUT_CHART :
      PDOutputType.OUTPUT_TABLE_ASOBJECT;

    const showStandardError = selectedStandardError === SE_ON ?
      true :
      false;

    const statistics = selectedStatistics?.map(stat => stat.statCode as StatType);

    let variablesSelected = (selectedVariables && selectedVariables.length) ?
      selectedVariables?.map( vr => vr.variableCode).join(',') :
      '';

    if (selectedSubgroups && selectedSubgroups.length) {
      variablesSelected += (variablesSelected ? ',' : '') + selectedSubgroups?.map(vr => vr.variableCode).join(',');
    }

    if (jurisdictionsSelected && statistics && itemRequest) {
      dispatch(
        changePDSelections({
          jurisdictionsSelected,
          output,
          showStandardError,
          statistics,
          variablesSelected
        })
      );
      ga4.onGA4ModifyPerformanceData(selectedOutput);
      dispatch(
        loadItemPerformanceDataStart()
      );

      setKeepFocus(false);
      openPerformanceTab();
    }

  },
  [
    dispatch,
    itemRequest,
    selectedJurisInfo,
    selectedOutput,
    selectedStandardError,
    selectedStatistics,
    selectedSubgroups,
    selectedVariables,
    openPerformanceTab
  ]);

  const handleExpandCollapse = useCallback((expand?: boolean)=>{

    if(expand == true){
      setAccExpanded(true);
      openPerformanceTab();
    } else {
      setAccExpanded(false);
    }

  },[setAccExpanded,openPerformanceTab]);

  const onDownload = useCallback(() => {
    if (isDownloadValid && !isDownloading) {
      const isExcel = selectedFormat === DOWNLOAD_FORM.EXCEL;

      const jurisdictionsSelected = selectedJurisInfo?.reduce((acc, curr, ind, arr) => {
        const delimiter = acc ? ',' : '';
        if (curr.isSelected) {
          acc += delimiter + curr.childList.map(child => child.jurisdictionCode).join(',');
        } else {
          acc += delimiter + curr.childList.filter( child => child.isSelected ).map( child => child.jurisdictionCode ).join(',');
        }
        return acc;
      }, '');

      const output = selectedOutput === PDCHART ?
        PDOutputType.OUTPUT_CHART :
        PDOutputType.OUTPUT_TABLE_ASOBJECT;

      const showStandardError = selectedStandardError === SE_ON ?
        true :
        false;

      const statistics = selectedStatistics?.map(stat => (stat.statCode === 'MN' ? '0' : '1'));

      let variablesSelected = (selectedVariables && selectedVariables.length) ?
        selectedVariables?.map( vr => vr.variableCode).join(',') :
        '';

      if (selectedSubgroups && selectedSubgroups.length) {
        variablesSelected += (variablesSelected ? ',' : '') + selectedSubgroups?.map(vr => vr.variableCode).join(',');
      }

      if (selectedFormat === DOWNLOAD_FORM.EXCEL) {
        const downloadPayload: DownloadRequest = {
          ItemListColHeaderLabels: systemID == '3' ?
            ITEM_LIST_COL_HEADER_LABELS.map(lb => (lb === 'Grade') ? 'Age' : lb) :
            ITEM_LIST_COL_HEADER_LABELS,
          ItemListDBColumns: systemID == '3' ?
            ITEM_LIST_DB_COLUMNS.map(lb => (lb == 'grade') ? 'age' : lb) :
            ITEM_LIST_DB_COLUMNS,
          ItemIDList: tabData != null ? (tabData.filter(tb => idsForDownload != null ? (!!idsForDownload[tb.itemTableID]) : '').map(tb => tb.itemTableID)) : [''],
          DLoadType:[DOWNLOAD_TYPES.ITEMLIST].concat(excelOptsForDownload.filter(opt => opt.isSelected).map(opt => opt.value as DOWNLOAD_TYPES)),
          Downloads: selectedFormat,
          SystemID: systemID ? systemID : '1',
          PerfOptions: {
            isLTT: false,
            output: output,
            jurisdictionsSelected: jurisdictionsSelected || '',
            variablesSelected: variablesSelected,
            statistics: statistics || [],
            showStandardError: showStandardError,
          }
        };
        if (downloadPayload.ItemIDList.length == 0){
          setModalContent(controls?.DwnldWarn ? controls?.DwnldWarn?.controlText : '');
          setModalType('DESC');
          setIsModalOpen(true);
        } else {
          ga4.onGA4DownloadContent(selectedFormat);
          dispatch(
            loadDownloadStart(downloadPayload)
          );
          setLocalDownloading(true);
          setkeepDwnDataFocus(false);
          setIsDownloadValid(false);
          const downloadExcelDataCheckBox = document.getElementById('nqt-xp--download-excel-data');
          if (downloadExcelDataCheckBox) {
            downloadExcelDataCheckBox.click();
          }
        }
      }

    }
  },[
    isDownloadValid,
    isDownloading,
    selectedFormat,
    excelOptsForDownload,
    idsForDownload,
    systemID,
    tabData,
    controls?.DwnldWarn,
    selectedJurisInfo,
    selectedStandardError,
    selectedStatistics,
    selectedSubgroups,
    selectedVariables,
    selectedOutput,
    dispatch
  ]);

  const updateSelected = useCallback((type: CHECKBOX_GROUP_TYPES) => {
    if (isCHECKBOX_GROUP_TYPES(type)) {
      setKeepFocus(true);
      switch (type) {
      case JURIS_INFO:
        jurisInfoTrees &&
        setSelectedJurisInfo(
          jurisInfoTrees.filter(jr => jr.isSelected || (jr.childList && jr.childList.filter(ch => ch.isSelected).length))
        );
        break;
      case VARIABLE_LIST:
        variablesList && setSelectedVariables(variablesList.filter(vr => vr.isSelected));
        break;
      case SUBGROUPS_LIST:
        subgroupsList && setSelectedSubgroups(subgroupsList.filter(vr => vr.isSelected));
        break;
      case STAT_LIST:
        statisticsList && setSelectedStatistics(statisticsList.filter(stat => stat.isSelected));
        break;
      case EXCEL_OPTION:
        setKeepFocus(false);

        if(isDownloadValid === true) {
          setIsDownloadValid(false);
          setkeepDwnDataFocus(false);
        } else {
          setIsDownloadValid(true);
          setkeepDwnDataFocus(true);
        }
        break;
      default:
        break;
      }
    }
  },[jurisInfoTrees, statisticsList, subgroupsList, variablesList, isDownloadValid]);

  const updateSelectedOutput = useCallback((outcome: PerformanceDataOutput) => {
    if (isPerformanceDataOutput(outcome)) {
      setSelectedOutput(outcome);
      setKeepFocus(true);
    }
    if (selectedOutput === PDTABLE ){
      setIsDisabled(true);
      setJurisExpanded(false);
    } else {
      setIsDisabled(false);
      setJurisExpanded(true);
    }
  }, [selectedOutput]);

  const updateSelectedStandardError = useCallback((outcome: StandardErrorOptions) => {
    if (isStandardErrorOptions(outcome)) {
      setSelectedStandardError(outcome);
      setKeepFocus(true);
    }
  }, []);

  /**
   * Resets selected subject and selected grade back to previous selection
   * and sets resetSelections to true, which fires an effect that resets
   * the rest of the fields
   */
  const resetToPDSelections = useCallback(()=> {
    const clonedSelections = cloneDeep(pdSelections);
    const jurisInfo = clonedSelections?.jurisdictionsSelected.split(',');
    const modifiedJurisInfoTrees = cloneDeep(jurisInfoTrees)?.map(jr => {
      if (jr.childList) {
        jr.childList.forEach(child => {
          if (jurisInfo?.includes(child.jurisdictionCode as string)) {
            child.isSelected = true;
          } else {
            child.isSelected = false;
          }
        });
      }
      jr.isSelected = jr.childList.length === jr.childList.filter(child => child.isSelected).length;
      return jr;
    });
    if (modifiedJurisInfoTrees) {
      setJurisInfoTrees(modifiedJurisInfoTrees);
      setSelectedJurisInfo(
        modifiedJurisInfoTrees.filter(jr => jr.isSelected || (jr.childList && jr.childList.filter(ch => ch.isSelected).length))
      );
    }
    const variables = clonedSelections?.variablesSelected.split(',');
    const modifiedVariablesList = cloneDeep(variablesList)?.map(vr => {
      if (variables?.includes(vr.variableCode as string)) {
        vr.isSelected = true;
      } else {
        vr.isSelected = false;
      }
      return vr;
    });
    if (modifiedVariablesList) {
      setVariablesList(modifiedVariablesList);
      setSelectedVariables(modifiedVariablesList.filter(vr => vr.isSelected));
    }

    const modifiedSubgroupsList = cloneDeep(subgroupsList)?.map(vr => {
      if (variables?.includes(vr.variableCode as string)) {
        vr.isSelected = true;
      } else {
        vr.isSelected = false;
      }
      return vr;
    });

    if (modifiedSubgroupsList) {
      setSubgroupsList(modifiedSubgroupsList);
      setSelectedSubgroups(modifiedSubgroupsList.filter(vr => vr.isSelected));
    }

    const statistics = clonedSelections?.statistics;
    const modifiedStatisticsList = cloneDeep(statisticsList)?.map(stat => {
      if (statistics?.includes(stat.statCode as StatType)) {
        stat.isSelected = true;
      } else {
        stat.isSelected = false;
      }
      return stat;
    });

    if (modifiedStatisticsList) {
      setStatisticsList(modifiedStatisticsList);
      setSelectedStatistics(modifiedStatisticsList.filter(stat => stat.isSelected));
    }

    setSelectedOutput(
      clonedSelections?.output === PDOutputType.OUTPUT_CHART ?
        PDCHART :
        PDTABLE
    );

    setSelectedStandardError(
      clonedSelections?.showStandardError === true ?
        SE_ON :
        SE_OFF
    );
  }, [jurisInfoTrees, pdSelections, statisticsList, subgroupsList, variablesList]);

  /**
   * Closes Modal and either fires onApply or resets focus to subject button
   * Important note: if event-listener is active, focus must be reset inside explorePanel
   * or event-listener will continuous open Modal
   */
  const onModalClose = useCallback((applyChanges?: boolean) => {
    setIsModalOpen(false);

    // If modalType === 'PROMPT, either apply changes or resetSelections
    // else reset focus back to queryPanel to make valid selections
    if (applyChanges) {
      onApply();
      setKeepFocus(false);
    } else if (modalType === 'PROMPT') {
      setKeepFocus(false);
      resetToPDSelections();
    } else if (modalType === 'DESC') {
      //setKeepFocus(true);
      resetToPDSelections();
    } else {
      if (onFocusEl.current) {
        onFocusEl.current.focus();
      }
    }
  },[modalType, onApply, resetToPDSelections]);


  /**
   * Updates Radio buttons and hides or shows the checkboxes
   */
  const updateSelectedFormat = useCallback((val: string) => {
    if (val && val in DownloadFormatsDict) {
      if (DownloadFormatsDict[val] !== selectedFormat) {
        if (DownloadFormatsDict[val] === DOWNLOAD_FORM.EXCEL) {
          setHideCheckboxes(true);
          setDisableExcelOptions(false);
        } else {
          setHideCheckboxes(false);
          setDisableExcelOptions(true);
          const newOpts = excelOptsForDownload.map(opt => ({ ...opt, isSelected: false }));
          setExcelOptsForDownload( newOpts);
        }
        setSelectedFormat(DownloadFormatsDict[val]);
      }
    }
  }, [selectedFormat, excelOptsForDownload]);



  /**
   * Focusin Event Handler
   */
  const onOutsideFocus = useCallback((event: Event) => {
    if (isModalOpen) {
      return;
    }
    const target = event.target as Element;
    if (target && explorePanelEl.current) {
      const {top, right, bottom, left} = explorePanelEl.current.getBoundingClientRect();
      const {x, y} = target.getBoundingClientRect();

      // if focus occur outside queryPanel, raise modal
      if (top > y || bottom < y || right < x || left > x) {
        if (isValid) {
          setModalContent(controls?.SearchApply ? controls?.SearchApply?.controlText : '');
          setModalType('PROMPT');
        } else {
          setModalContent(controls?.XplrWarn ? controls?.XplrWarn?.controlText : '');
          setModalType('DESC');
        }
        setIsModalOpen(true);
      }
    }
  }, [isModalOpen, isValid, controls]);




  /**
  * Focusin Event Handler for DownloadData
  */
  const onOutsideFocusForDownload = useCallback((event: Event) => {
    if (isModalOpen) {
      return;
    }
    const target = event.target as Element;

    if (target && explorePanelEl.current) {
      const {top, right, bottom, left} = explorePanelEl.current.getBoundingClientRect();
      const {x, y} = target.getBoundingClientRect();

      if (top > y || bottom < y || right < x || left > x) {

        if(isDownloadValid){
          setkeepDwnDataFocus(false);
          //setIsDownloadValid(false);
          const downloadExcelDataCheckBox = document.getElementById('nqt-xp--download-excel-data') as HTMLInputElement;
          downloadExcelDataCheckBox.click();
          window.scrollTo(0, 0 );
        }
      }
    }



  },[isDownloadValid, isModalOpen]);

  // fires on mount, creates checkbox and radio objects
  useEffect(() => {
    if (controls) {

      const formats = [
        {
          label: controls?.XplrExcel?.controlText,
          value: DOWNLOAD_FORM.EXCEL,
          isSelected: true
        }
      ];

      const excelOptions = [
        {
          label: controls?.XplrDownLoadData?.controlText,
          value: DOWNLOAD_TYPES.PERFDATA,
          isSelected: false
        }
      ];

      setExcelOptsForDownload(excelOptions);
      setFormats(formats);

    }
  }, [controls]
  );

  useEffect(() => {
    if (item && pdSelectors) {
      dispatch(loadItemPerformanceDataStart());
    }
  }, [dispatch, item, pdSelectors]);

  // Fires on mount, when Performance Data Selectors endpoint returns with result
  // Builds checkbox trees and sets default selections
  useEffect(() => {
    if (pdSelectors) {
      const clonedPDSelectors = cloneDeep(pdSelectors);
      const jurisInfo = clonedPDSelectors.jurisInfo;
      const variablesList = clonedPDSelectors.variablesList;
      const subgroupsList = clonedPDSelectors.subgroupsList;
      const statisticsList = clonedPDSelectors.statisticsList;

      if (jurisInfo) {
        const jurisInfoTrees = jurisInfo.reduce(jurisInfoReducer(clonedPDSelectors), []);
        setJurisInfoTrees(jurisInfoTrees);
        setSelectedJurisInfo(
          jurisInfoTrees.filter(jr => jr.isSelected || (jr.childList && jr.childList.filter(ch => ch.isSelected).length))
        );
      }

      if (variablesList) {
        const entries = Object.entries(variablesList);
        const variables = entries.reduce(variableListReducer(clonedPDSelectors), []);
        setVariablesList(variables);
        setSelectedVariables(variables.filter(vr => vr.isSelected));
      }

      if (subgroupsList) {
        const entries = Object.entries(subgroupsList);
        const subgroups = entries.reduce(subgroupsListReducer(clonedPDSelectors), []);
        setSubgroupsList(subgroups);
        setSelectedSubgroups(subgroups.filter(vr => vr.isSelected));
      }

      if (statisticsList) {
        const entries = Object.entries(statisticsList);
        const statistics = entries.reduce(statisticsListReducer, []);
        setStatisticsList(statistics);
        setSelectedStatistics(statistics.filter(stat=> stat.isSelected));
      }

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdSelectors]);


  // Fires after a selection is made; sets isValid
  useEffect(() => {
    if (
      isPerformanceDataOutput(selectedOutput) &&
      isStandardErrorOptions(selectedStandardError) &&
      (selectedJurisInfo && selectedJurisInfo.length) &&
      (
        (selectedVariables && selectedVariables.length) ||
        (selectedSubgroups && selectedSubgroups.length)
      ) &&
        selectedStatistics && selectedStatistics.length
    )
    {
      setIsValid(true);

    } else {
      setIsValid(false);
    }
  }, [selectedJurisInfo, selectedOutput, selectedStandardError, selectedStatistics, selectedSubgroups, selectedVariables]);

  // fires when keepFocus is toggled - keeps user locked to explorePanel
  useEffect(() => {
    if (keepFocus) {
      window.addEventListener('focusin', onOutsideFocus);
    } else {
      window.removeEventListener('focusin', onOutsideFocus);
    }
    return () => window.removeEventListener('focusin', onOutsideFocus);

  },[keepFocus, isModalOpen, isValid, onOutsideFocus]);

  // fires when keepDwnDataFocus is toggled - keeps user locked to downloadpanel
  useEffect(() => {
    if (keepDwnDataFocus) {
      window.addEventListener('focusin', onOutsideFocusForDownload);
    } else {
      window.removeEventListener('focusin', onOutsideFocusForDownload);
    }
    return () => window.removeEventListener('focusin', onOutsideFocusForDownload);

  },[keepDwnDataFocus, isModalOpen, isDownloadValid, onOutsideFocusForDownload]);

  // fires when selections are changed
  useEffect(() => {

    if ((selectedFormat === DOWNLOAD_FORM.EXCEL)) {
      //setIsDownloadValid(true);
    } else {
      setHideCheckboxes(true);
      //setIsDownloadValid(false);
    }
  }, [selectedFormat, hideCheckboxes]);

  // resets the local downloading flag once the download completes, fails, or is cancelled
  useEffect(() => {
    if (!isDownloading && localDownloading) {
      setLocalDownloading(false);
    }
  }, [isDownloading, localDownloading]);

  return (
    <section className="nqt-xp">
      <Modal
        bodyText={modalContent}
        headerText={controls?.Explore?.controlText}
        open={isModalOpen}
        onClose={onModalClose}
        shouldReturnFocusAfterClose={true}
        windowType={modalType}/>

      <div className="accordion accordion-flush row gy-4">
        <div className="accordion-it" ref={explorePanelEl}>
          <h3 className="accordion-header" id="headingTwo">
            <button className="nqt-xp--accordion-button accordion-button collapsed"
              ref={onFocusEl}
              onClick={
                (e) => !e.currentTarget.classList.contains('collapsed') ?
                  handleExpandCollapse(true) :
                  handleExpandCollapse(false)
              }
              onAuxClick={() => openPerformanceTab()}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo">
              <span className="accordion-header--label">
                {controls?.Explore?.controlText}
              </span>
              {
                accExpanded ?
                  <FontAwesomeIcon className='fa-plus' icon={faMinus}/> :
                  <FontAwesomeIcon className='fa-plus' icon={faPlus}/>
              }
            </button>
          </h3>
          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#make-selections-accordion">
            <div className="accordion-body px-1 py-2">
              <div className="row">
                <div className="col">
                  <div className="row row-cols-1 gy-2">
                    <div className="col">
                      <fieldset id='nqt-fieldset' className={'xp--radio-fieldset radio-column' } role="radiogroup">
                        <legend className="visually-hidden">{controls?.XplrOutputType?.controlText}</legend>
                        <label htmlFor="xp-chart" className="nqt-input-radio-container">
                          <input className='d-none'
                            type="radio"
                            id="xp-chart"
                            name="chartOrTable"
                            checked={selectedOutput === PDCHART}
                            onClick={() => radioOutput1.current && radioOutput1.current.focus()}
                            onChange={(e) => updateSelectedOutput(e.currentTarget.value as PerformanceDataOutput)}
                            value={PDCHART}/>
                          <span tabIndex={0}
                            aria-checked={selectedOutput === PDCHART}
                            ref={radioOutput1}
                            role="radio"
                            className="nqt-input-radio"
                            onKeyUp={(e) => (e.key === ' ' || e.key === 'Enter') && updateSelectedOutput(PDCHART)}>
                          </span>
                          <span className='nqt-input-radio-label ps-1'>{controls?.XplrChart?.controlText}</span>
                        </label>
                        <label htmlFor="xp-table" className="nqt-input-radio-container">
                          <input className='d-none'
                            type="radio"
                            id="xp-table"
                            name="chartOrTable"
                            checked={selectedOutput === PDTABLE}
                            onClick={() => radioOutput2.current && radioOutput2.current.focus()}
                            onChange={(e) => updateSelectedOutput(e.currentTarget.value as PerformanceDataOutput)}
                            value={PDTABLE}/>
                          <span
                            aria-checked={selectedOutput === PDTABLE}
                            ref={radioOutput2}
                            role="radio"
                            tabIndex={0}
                            className="nqt-input-radio"
                            onKeyUp={(e) => (e.key === ' ' || e.key === 'Enter') && updateSelectedOutput(PDTABLE)}>
                          </span>
                          <span className='nqt-input-radio-label ps-1'>{controls?.XplrTable?.controlText}</span>
                        </label>
                      </fieldset>
                    </div>


                    {/* Jurisdictions */}
                    <div className="col">
                      <p className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-text` }>{controls?.XplrSelect?.controlText}</p>
                    </div>
                    <div className="col">
                      <button disabled={selectedOutput === PDTABLE ? false : true} className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header` }
                        onClick={() => setJurisExpanded(!jurisExpanded)}>
                        <div className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-icon-box` }>
                          {
                            jurisExpanded ?
                              <FontAwesomeIcon size='xs' icon={faMinus} className='fa-icon'/> :
                              <FontAwesomeIcon size='xs' icon={faPlus} className='fa-icon'/>
                          }
                        </div>
                        <h3 className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header-text` }>
                          {controls?.XplrJurisdiction?.controlText}
                        </h3>
                      </button>
                      <div className={`xp-acc--header-children${jurisExpanded ? '' : ' d-none'} ${selectedOutput === PDTABLE ? '' : 'disabled'}`}>
                        {
                          jurisInfoTrees &&
                          jurisInfoTrees.map((juris, ind) => (
                            <li key={`xp-juris-${ind}`}>
                              <NQTMixedCheckBox id={`xp-juris-${ind}`}
                                containerClass={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-checkbox-container` }
                                checkBoxObj={juris}
                                childLabelAttribute='jurisdictionLabel'
                                childStyle={childStyle}
                                collapsable={true}
                                defaultCollapsed={ ind !== 0 }
                                label={juris.label}
                                type={JURIS_INFO}
                                disabled={isDisabled}
                                updateHandler={updateSelected}/>
                            </li>
                          ))
                        }
                      </div>
                    </div>
                    {/* Variables */}
                    <div className="col">
                      <button disabled={selectedOutput === PDTABLE ? false : true} className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header` }
                        onClick={() => setVarExpanded(!varExpanded)}>
                        <div className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-icon-box` }>
                          {
                            varExpanded ?
                              <FontAwesomeIcon size='xs' icon={faMinus} className='fa-icon'/> :
                              <FontAwesomeIcon size='xs' icon={faPlus} className='fa-icon'/>
                          }
                        </div>
                        <h3 className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header-text` }>
                          {controls?.XplrVars?.controlText}
                        </h3>
                      </button>
                      <div className={`xp-acc--header-children${varExpanded ? '' : ' d-none'}`}>
                        {
                          variablesList &&
                          variablesList.map((vr, ind) => (
                            <li key={'xp-vars-' + ind}>
                              <NQTCheckBox
                                checkBoxObj={vr}
                                containerClass={`${isDisabled === true ? 'disabled' : '' } xp-checkbox-container` }
                                id={'xp-vars-' + ind}
                                label={vr.variableLabel && typeof vr.variableLabel === 'string' ? vr.variableLabel : ''}
                                type={VARIABLE_LIST}
                                disabled={isDisabled}
                                updateHandler={updateSelected}
                              />
                            </li>
                          ))
                        }
                        {
                          subgroupsList &&
                          <ul className="xp--subgroups-container">
                            <h3 className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header` }>FILTER BY SUBGROUPS:</h3>
                            {
                              subgroupsList.map((vr, ind) => (
                                <li key={'xp-vars-subgroup-' + ind}>
                                  <NQTCheckBox
                                    checkBoxObj={vr}
                                    containerClass={`${isDisabled === true ? 'disabled' : '' } xp-checkbox-container` }
                                    id={'xp-vars-subgroup-' + ind}
                                    label={vr.variableLabel && typeof vr.variableLabel === 'string' ? vr.variableLabel : ''}
                                    type={SUBGROUPS_LIST}
                                    disabled={isDisabled}
                                    updateHandler={updateSelected}
                                  />
                                </li>
                              ))
                            }
                          </ul>
                        }
                      </div>
                    </div>
                    {/* STATS */}
                    <div className="col">
                      <button disabled={selectedOutput === PDTABLE ? false : true} className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header`}
                        onClick={() => setStatExpanded(!statExpanded)}>
                        <div className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-icon-box` }>
                          {
                            statExpanded ?
                              <FontAwesomeIcon size='xs' icon={faMinus} className='fa-icon'/> :
                              <FontAwesomeIcon size='xs' icon={faPlus} className='fa-icon'/>
                          }
                        </div>
                        <h3 className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header-text` }>
                          {controls?.XplrStats?.controlText}
                        </h3>
                      </button>
                      <div className={`xp-acc--header-children${statExpanded ? '' : ' d-none'}`}>
                        {
                          statisticsList &&
                          statisticsList?.map((stat, ind) => (
                            <li key={'xp-stat-' + ind}>
                              <NQTCheckBox
                                checkBoxObj={stat}
                                containerClass={`${isDisabled === true ? 'disabled' : '' } xp-checkbox-container` }
                                id={'xp-stat-' + ind}
                                label={stat.statLabel && typeof stat.statLabel === 'string' ? stat.statLabel : ''}
                                type={STAT_LIST}
                                disabled={isDisabled}
                                updateHandler={updateSelected}
                              />
                            </li>
                          ))
                        }
                      </div>
                    </div>
                    <div className="col">
                      <div className="xp--standard-error-container">
                        <h3 className={`${selectedOutput === PDTABLE ? '' : 'disabled' } xp-acc--header` }>{controls?.XplrSE?.controlText}:</h3>
                        <fieldset className='xp--radio-fieldset' role="radiogroup" disabled={isDisabled}>
                          <legend className="visually-hidden">{controls?.XplrToggleSE?.controlText}</legend>
                          <label htmlFor="xp-se-on" className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio-container` }>
                            <input className='d-none'
                              type="radio"
                              id="xp-se-on"
                              name="standardError"
                              checked={selectedStandardError === SE_ON}
                              onChange={(e) => updateSelectedStandardError(e.currentTarget.value as StandardErrorOptions)}
                              onClick={() => radioStandardError1.current && radioStandardError1.current.focus()}
                              value={SE_ON}/>
                            <span tabIndex={0}
                              aria-checked={selectedStandardError === SE_ON}
                              role="radio"
                              ref={radioStandardError1}
                              onKeyUp={(e) => (e.key === ' '||e.key === 'Enter') && updateSelectedStandardError(SE_ON)}
                              className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio` }></span>
                            <span className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio-label ps-1` }>{controls?.XplrSEOn?.controlText}</span>
                          </label>
                          <label htmlFor="xp-se-off" className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio-container ps-2` }>
                            <input className='d-none'
                              type="radio"
                              id="xp-se-off"
                              name="standardError"
                              onChange={(e) => updateSelectedStandardError(e.currentTarget.value as StandardErrorOptions)}
                              onClick={() => radioStandardError2.current && radioStandardError2.current.focus()}
                              checked={selectedStandardError === SE_OFF}
                              value={SE_OFF}/>
                            <span tabIndex={0}
                              role="radio"
                              aria-checked={selectedStandardError === SE_OFF}
                              ref={radioStandardError2}
                              onKeyUp={(e) => (e.key === ' '||e.key === 'Enter') && updateSelectedStandardError(SE_OFF)}
                              className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio` }></span>
                            <span className={`${selectedOutput === PDTABLE ? '' : 'disabled' } nqt-input-radio-label ps-1` }>{controls?.XplrSEOff?.controlText}</span>
                          </label>
                        </fieldset>
                      </div>
                    </div>
                    <div className="nqt-xp--apply col">
                      <button
                        disabled={!keepFocus || !isValid }
                        onClick={() => onApply()}
                        className='nqt-submit-button nqt-xp--apply-button'
                        type='submit'>{controls?.XplrApply?.controlText}</button>
                    </div>

                    <div className="col">
                      <div className='nqt-dp--divider-solid'></div>
                      <p className="xp-text" dangerouslySetInnerHTML={{__html: controls?.XplrDownloadTTL ? controls?.XplrDownloadTTL?.controlText : ''}}></p>
                    </div>
                    <div className="col">
                      <fieldset>
                        { formats.find(fmt => fmt.value === DOWNLOAD_FORM.EXCEL) &&
                            excelOptsForDownload.length > 0 &&
                            excelOptsForDownload.map((option, ind) => (
                              <NQTCheckBox key={ind}
                                id={'nqt-xp--download-excel-data'}
                                containerClass="dp-checkbox-container"
                                checkBoxObj={option}
                                label={option.label}
                                type={EXCEL_OPT_TYPE}
                                disabled={!!(isDownloadDisabled || isDownloading)}
                                updateHandler={updateSelected}/>
                            ))
                        }
                      </fieldset>
                    </div>
                    <div className="nqt-xp-shl-inline">
                      <h3 className="acc-header nqt-dp--format">{controls?.XplrFormat?.controlText}</h3>
                      <fieldset className="xp--radio-fieldset" role="radiogroup">
                        {
                          formats.length > 0 &&
                          formats.map((format, ind) => (

                            <div key={ind} className='xp--radio mt-1'>
                              <NQTRadioButton
                                checked={selectedFormat === format?.value}
                                id={'xp-dp--radio-' + ind}
                                name='xp-download-formats'
                                radioClassContainer='xp-dp--radio-container w-100'
                                value={format.value.toString()}
                                label={format.label}
                                updateHandler={updateSelectedFormat}
                              />
                            </div>
                          ))
                        }
                      </fieldset>
                    </div>

                    <div className="nqt-xp--download col">
                      { isDownloading && localDownloading && <Spinner size={20} containerClassName="nqt-xp--download-spinner" />}
                      <button
                        disabled={!!(!isDownloadValid || !keepDwnDataFocus || isDownloading)}
                        onClick={() => onDownload()}
                        className='nqt-submit-button nqt-xp--download-button'
                        type='submit'>{controls?.Xplr_Download?.controlText}</button>
                    </div>
                    {
                      isDownloading && localDownloading &&
                      <div className="nqt-dp--progress-container col" role="progressbar"
                        aria-valuenow={downloadProgress?.completed ?? 0}
                        aria-valuemin={0}
                        aria-valuemax={downloadProgress?.total ?? 0}>
                        <div className="nqt-dp--progress-label">
                          {
                            downloadProgress && downloadProgress.total > 0 ?
                              `Processing ${downloadProgress.completed} of ${downloadProgress.total} sheets` :
                              'Preparing download...'
                          }
                        </div>
                        <div className="nqt-dp--progress-bar-track">
                          <div
                            className="nqt-dp--progress-bar-fill"
                            style={{ width: `${downloadProgress && downloadProgress.total > 0 ? Math.min(100, Math.round((downloadProgress.completed / downloadProgress.total) * 100)) : 0}%` }}
                          ></div>
                        </div>
                      </div>
                    }
                    {
                      isDownloading && localDownloading &&
                      <div className="nqt-dp--cancel col">
                        <button
                          onClick={() => dispatch(loadDownloadCancel())}
                          className='nqt-cancel-button nqt-dp--cancel-button'
                          type='button'>Cancel</button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};